import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "diagram-section" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_row = _resolveComponent("v-row")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_v_row, { class: "mt-4" }, {
      default: _withCtx(() => [
        _createVNode(_component_v_col, {
          cols: "12",
          md: "6"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_v_card, {
              class: "diagram-panel",
              rounded: "lg",
              variant: "flat"
            }, {
              default: _withCtx(() => _cache[0] || (_cache[0] = [
                _createElementVNode("div", { class: "diagram-head" }, [
                  _createElementVNode("span", { class: "diagram-kind" }, "Workflow"),
                  _createElementVNode("span", { class: "diagram-shape" }, "Fan-out")
                ], -1),
                _createElementVNode("svg", {
                  class: "diagram-svg",
                  viewBox: "0 0 460 412",
                  role: "img",
                  "aria-labelledby": "wfT wfD"
                }, [
                  _createElementVNode("title", { id: "wfT" }, "Workflow fan-out diagram"),
                  _createElementVNode("desc", { id: "wfD" }, "A request fans out to four agents working in parallel; their responses feed into one main agent that produces a single answer."),
                  _createElementVNode("defs", null, [
                    _createElementVNode("marker", {
                      id: "dgmA",
                      class: "dg-arrow",
                      markerWidth: "10",
                      markerHeight: "9",
                      refX: "6.5",
                      refY: "3",
                      orient: "auto",
                      markerUnits: "userSpaceOnUse"
                    }, [
                      _createElementVNode("path", { d: "M0 0 L6.5 3 L0 6 Z" })
                    ])
                  ]),
                  _createElementVNode("g", {
                    class: "dg-line",
                    fill: "none",
                    "stroke-width": "1.6",
                    "marker-end": "url(#dgmA)"
                  }, [
                    _createElementVNode("path", { d: "M230 58 L63 146" }),
                    _createElementVNode("path", { d: "M230 58 L177 146" }),
                    _createElementVNode("path", { d: "M230 58 L291 146" }),
                    _createElementVNode("path", { d: "M230 58 L405 146" }),
                    _createElementVNode("path", { d: "M63 198 L158 264" }),
                    _createElementVNode("path", { d: "M177 198 L205 264" }),
                    _createElementVNode("path", { d: "M291 198 L255 264" }),
                    _createElementVNode("path", { d: "M405 198 L302 264" }),
                    _createElementVNode("path", { d: "M230 324 L230 352" })
                  ]),
                  _createElementVNode("g", null, [
                    _createElementVNode("rect", {
                      class: "dg-node",
                      x: "165",
                      y: "16",
                      width: "130",
                      height: "40",
                      rx: "10"
                    }),
                    _createElementVNode("rect", {
                      class: "dg-node",
                      x: "16",
                      y: "150",
                      width: "94",
                      height: "48",
                      rx: "9"
                    }),
                    _createElementVNode("rect", {
                      class: "dg-node",
                      x: "130",
                      y: "150",
                      width: "94",
                      height: "48",
                      rx: "9"
                    }),
                    _createElementVNode("rect", {
                      class: "dg-node",
                      x: "244",
                      y: "150",
                      width: "94",
                      height: "48",
                      rx: "9"
                    }),
                    _createElementVNode("rect", {
                      class: "dg-node",
                      x: "358",
                      y: "150",
                      width: "94",
                      height: "48",
                      rx: "9"
                    }),
                    _createElementVNode("rect", {
                      class: "dg-acc",
                      x: "120",
                      y: "270",
                      width: "220",
                      height: "54",
                      rx: "11"
                    }),
                    _createElementVNode("rect", {
                      class: "dg-node",
                      x: "165",
                      y: "356",
                      width: "130",
                      height: "40",
                      rx: "10"
                    })
                  ]),
                  _createElementVNode("g", { "text-anchor": "middle" }, [
                    _createElementVNode("text", {
                      class: "dg-td",
                      x: "230",
                      y: "40",
                      "font-size": "11",
                      "letter-spacing": "1.6"
                    }, "REQUEST"),
                    _createElementVNode("text", {
                      class: "dg-t",
                      x: "63",
                      y: "179",
                      "font-size": "14",
                      "font-weight": "600"
                    }, "Agent"),
                    _createElementVNode("text", {
                      class: "dg-t",
                      x: "177",
                      y: "179",
                      "font-size": "14",
                      "font-weight": "600"
                    }, "Agent"),
                    _createElementVNode("text", {
                      class: "dg-t",
                      x: "291",
                      y: "179",
                      "font-size": "14",
                      "font-weight": "600"
                    }, "Agent"),
                    _createElementVNode("text", {
                      class: "dg-t",
                      x: "405",
                      y: "179",
                      "font-size": "14",
                      "font-weight": "600"
                    }, "Agent"),
                    _createElementVNode("text", {
                      class: "dg-t",
                      x: "230",
                      y: "302",
                      "font-size": "15",
                      "font-weight": "700"
                    }, "Main agent"),
                    _createElementVNode("text", {
                      class: "dg-td",
                      x: "230",
                      y: "380",
                      "font-size": "11",
                      "letter-spacing": "1.6"
                    }, "ONE ANSWER")
                  ])
                ], -1),
                _createElementVNode("p", { class: "diagram-desc text-medium-emphasis" }, "Several agents take on the same request in parallel. Each works independently, then every response is fed back into one main agent that reads them all and produces a single answer.", -1)
              ])),
              _: 1,
              __: [0]
            })
          ]),
          _: 1
        }),
        _createVNode(_component_v_col, {
          cols: "12",
          md: "6"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_v_card, {
              class: "diagram-panel",
              rounded: "lg",
              variant: "flat"
            }, {
              default: _withCtx(() => _cache[1] || (_cache[1] = [
                _createElementVNode("div", { class: "diagram-head" }, [
                  _createElementVNode("span", { class: "diagram-kind" }, "Factory"),
                  _createElementVNode("span", { class: "diagram-shape" }, "Chain")
                ], -1),
                _createElementVNode("svg", {
                  class: "diagram-svg",
                  viewBox: "0 0 460 412",
                  role: "img",
                  "aria-labelledby": "fcT fcD"
                }, [
                  _createElementVNode("title", { id: "fcT" }, "Factory chain diagram"),
                  _createElementVNode("desc", { id: "fcD" }, "Input passes through a sequence of steps — agent, nested workflow, agent — each step's output feeding the next step's input, ending in a result."),
                  _createElementVNode("defs", null, [
                    _createElementVNode("marker", {
                      id: "dgmB",
                      class: "dg-arrow",
                      markerWidth: "10",
                      markerHeight: "9",
                      refX: "6.5",
                      refY: "3",
                      orient: "auto",
                      markerUnits: "userSpaceOnUse"
                    }, [
                      _createElementVNode("path", { d: "M0 0 L6.5 3 L0 6 Z" })
                    ])
                  ]),
                  _createElementVNode("g", {
                    class: "dg-line",
                    fill: "none",
                    "stroke-width": "1.6",
                    "marker-end": "url(#dgmB)"
                  }, [
                    _createElementVNode("path", { d: "M230 56 L230 88" }),
                    _createElementVNode("path", { d: "M230 144 L230 174" }),
                    _createElementVNode("path", { d: "M230 230 L230 260" }),
                    _createElementVNode("path", { d: "M230 316 L230 346" })
                  ]),
                  _createElementVNode("g", { class: "dg-dot" }, [
                    _createElementVNode("circle", {
                      cx: "230",
                      cy: "72",
                      r: "3.1"
                    }),
                    _createElementVNode("circle", {
                      cx: "230",
                      cy: "159",
                      r: "3.1"
                    }),
                    _createElementVNode("circle", {
                      cx: "230",
                      cy: "245",
                      r: "3.1"
                    }),
                    _createElementVNode("circle", {
                      cx: "230",
                      cy: "331",
                      r: "3.1"
                    })
                  ]),
                  _createElementVNode("g", null, [
                    _createElementVNode("rect", {
                      class: "dg-node",
                      x: "165",
                      y: "16",
                      width: "130",
                      height: "40",
                      rx: "10"
                    }),
                    _createElementVNode("rect", {
                      class: "dg-node",
                      x: "110",
                      y: "92",
                      width: "240",
                      height: "52",
                      rx: "11"
                    }),
                    _createElementVNode("rect", {
                      class: "dg-acc",
                      x: "110",
                      y: "178",
                      width: "240",
                      height: "52",
                      rx: "11"
                    }),
                    _createElementVNode("rect", {
                      class: "dg-node",
                      x: "110",
                      y: "264",
                      width: "240",
                      height: "52",
                      rx: "11"
                    }),
                    _createElementVNode("rect", {
                      class: "dg-node",
                      x: "165",
                      y: "350",
                      width: "130",
                      height: "40",
                      rx: "10"
                    })
                  ]),
                  _createElementVNode("g", { "text-anchor": "middle" }, [
                    _createElementVNode("text", {
                      class: "dg-td",
                      x: "230",
                      y: "40",
                      "font-size": "11",
                      "letter-spacing": "1.6"
                    }, "INPUT"),
                    _createElementVNode("text", {
                      class: "dg-t",
                      x: "230",
                      y: "123",
                      "font-size": "15",
                      "font-weight": "600"
                    }, "Agent"),
                    _createElementVNode("text", {
                      class: "dg-t",
                      x: "230",
                      y: "209",
                      "font-size": "15",
                      "font-weight": "700"
                    }, "Workflow"),
                    _createElementVNode("text", {
                      class: "dg-t",
                      x: "230",
                      y: "295",
                      "font-size": "15",
                      "font-weight": "600"
                    }, "Agent"),
                    _createElementVNode("text", {
                      class: "dg-td",
                      x: "230",
                      y: "374",
                      "font-size": "11",
                      "letter-spacing": "1.6"
                    }, "RESULT")
                  ])
                ], -1),
                _createElementVNode("p", { class: "diagram-desc text-medium-emphasis" }, "Steps run in sequence. Each step's output becomes the next step's input — and any step can be a single agent or an entire workflow nested inside.", -1)
              ])),
              _: 1,
              __: [1]
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _cache[2] || (_cache[2] = _createElementVNode("p", { class: "diagram-note text-disabled" }, "Workflows fan out · factories chain · compose them however the work demands.", -1))
  ]))
}